<template>
	<div id='' class='gPageBorder' v-loading='loading'>
		<el-form class='gForm' label-position="right" ref="cer" :rules='rules' label-width="12.5%" :model='form'
			style=''>

			<el-form-item :label="$t('app_secrname')" prop='secretName'>
				<el-input v-model='form.secretName'></el-input>
			</el-form-item>

			<el-form-item :label="$t('app_keyType')" prop=''>
				<el-select v-model="form.keyType" :placeholder="$t('app_keyType')">
					<el-option v-for="(item,index) in keyType_list" :key="index" :label="item.label"
						:value="item.value">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item :label="$t('app_keyUpIndex')" prop=''>
				<el-select v-model="form.encryptionIndex" :placeholder="$t('app_keyUpIndex')">
					<el-option v-for="(item,index) in keyIndex_list" :key="index" :label="item.label"
						:value="item.value">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item :label="$t('app_keyDlIndex')" prop=''>
				<el-select v-model="form.downloadIndex" :placeholder="$t('app_keyDlIndex')">
					<el-option v-for="(item,index) in keyDown_list" :key="index" :label="item.label"
						:value="item.value">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item :label="$t('app_Algorithm_mode')" prop=''>
				<el-select v-model="form.algorithmModel" :placeholder="$t('app_Algorithm_mode')">
					<el-option v-for="(item,index) in An_list" :key="index" :label="item.label" :value="item.value">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="分量1" prop='' v-show="show_bdk">
				<el-input v-model='form.component1' @blur="is_hidden"></el-input>
			</el-form-item>
			<el-form-item label="分量2" prop=''>
				<el-input v-model='form.component2'></el-input>
			</el-form-item>


			<el-form-item>
				<el-button type='' style='' @click="cancel">{{$t('app_cancel')}}</el-button>
				<el-button type='primary' style='' @click="submit">{{$t('app_submit')}}</el-button>

			</el-form-item>
		</el-form>

	</div>
</template>

<style>
</style>

<script>
	import axios from 'axios'
	import {
		baseurl,
		focusEvent,
		urlAssets
	} from '../../api/url'
	export default {
		
		data() {
			return {
				keyType_list: [{
						id: 0,
						label: "PIN",
						value: 0
					},
					{
						id: 1,
						label: "MAC",
						value: 1
					},
					{
						id: 2,
						label: "TD",
						value: 2
					},
					{
						id: 3,
						label: "MAIN",
						value: 3
					},
					{
						id: 4,
						label: "PTK",
						value: 4
					},
					{
						id: 5,
						label: "CBC_TD",
						value: 130
					},
					{
						id: 6,
						label: "CBC_PIN",
						value: 128
					},
					{
						id: 7,
						label: "CBC_MAC",
						value: 129
					}
				],
				keyIndex_list: [{
						id: 0,
						label: "-1",
						value: -1
					},
					{
						id: 1,
						label: "0",
						value: 0
					},
					{
						id: 2,
						label: "1",
						value: 1
					},
					{
						id: 3,
						label: "2",
						value: 2
					},
					{
						id: 4,
						label: "3",
						value: 3
					},
					{
						id: 5,
						label: "4",
						value: 4
					},
					{
						id: 6,
						label: "5",
						value: 5
					},
					{
						id: 7,
						label: "6",
						value: 6
					},
					{
						id: 8,
						label: "7",
						value: 7
					},
					{
						id: 9,
						label: "8",
						value: 8
					}
				],
				keyDown_list: [{
						id: 1,
						label: "0",
						value: 0
					},
					{
						id: 2,
						label: "1",
						value: 1
					},
					{
						id: 3,
						label: "2",
						value: 2
					},
					{
						id: 4,
						label: "3",
						value: 3
					},
					{
						id: 5,
						label: "4",
						value: 4
					},
					{
						id: 6,
						label: "5",
						value: 5
					},
					{
						id: 7,
						label: "6",
						value: 6
					},
					{
						id: 8,
						label: "7",
						value: 7
					},
					{
						id: 9,
						label: "8",
						value: 8
					}
				],
				An_list: [{
						id: 0,
						label: "MODE_3DES",
						value: 1
					},
					{
						id: 1,
						label: "MODE_SM4",
						value: 2
					},
					{
						id: 2,
						label: "MODE_AES",
						value: 3
					},
					{
						id: 3,
						label: "MODE_DUKPT_DES",
						value: 8193
					},
					{
						id: 4,
						label: "MODE_DUKPT_SM4",
						value: 8194
					},
					{
						id: 5,
						label: "MODE_FIXED_DES",
						value: 16385
					},
					{
						id: 6,
						label: "MODE_FIXED_SM4",
						value: 16386
					}
				],
				show_bdk: true,
				key_detail:{},
				show_edit:false,




				loading: 0,
				cer: {
					name: '',
					mark: '',
					curl: '',
					purl: '',
					mech: ''
				},
				form: {
					secretName: '',
					keyType: "",
					encryptionIndex: "",
					downloadIndex: "",
					algorithmModel: "",
					component1:"",
					component2:""
				},
				rules: {
					secretName: [{
						required: true,
						message: this.$t('app_input'),
						trigger: 'blur'
					}],
					mech: [{
						required: true,
						message: this.$t('app_selectChannel'),
						trigger: 'blur'
					}],
					curl: [{
						required: true,
						message: this.$t('app_plsUlPbCer'),
						trigger: 'blur'
					}]
				}
			}
		},
		created() {
		},
		methods: {
			is_hidden() {
				this.show_bdk = false;
			},
			cancel() {
				this.$router.go(-1)
			},
			submit() {
				this.$refs['cer'].validate((valid) => {
					if (valid) {
						console.log("通过校验")
						console.log(this.form)
						axios.post(`${baseurl}/secret/add.do`, this.form).then(res => {
							//console.log("打印返回列表2");
							//console.log(res.data);
							if (res.data.status == 200) {
								this.$message.success("添加成功")
								this.$router.go(-1)
								this.loading = false;
							} else {
								this.loading = false;
							}
						
						})
					} else {
						return false
					}
				})
			},
		},
	}
</script>



// WEBPACK FOOTER //
// keyManagement_new.vue?5f663440